'use strict';

const Handlebars = require('hbsfy/runtime');
const lang = require('./lang');
const commonmark = require('commonmark');

module.exports = function () {

  // PARTIALS

  Handlebars.registerPartial('header', require('./templates/partials/header.hbs'));
  Handlebars.registerPartial('basicFooter', require('./templates/partials/basic-footer.hbs'));

  // HELPERS

  // when an image url contains a hash symbol (#), that symbol is not automatically encoded by handlebars,
  // since a hash in an URL is valid and can indicate an anchor.
  // For images containing a hash symbol in their filenames it is necessary to encode that symbol explicitly.
  Handlebars.registerHelper('encodeHashSymbol', (string) => string ? string.replace('#', '%23') : '');

  Handlebars.registerHelper('locale', () => lang.locale);

  // example on how to use with parameter: {{langGet 'print_footer' id='123'}}
  Handlebars.registerHelper('langGet', (key, options) => lang.get(key, options.hash));

  Handlebars.registerHelper('defaultValue', (originalValue, defaultValue) => (originalValue ? originalValue : defaultValue));

  Handlebars.registerHelper('markdown', (str) => {
    const reader = new commonmark.Parser();
    const writer = new commonmark.HtmlRenderer();
    return writer.render(reader.parse(str));
  });

  Handlebars.registerHelper('trackName', (location) => {
    if (location._track)
      return location._track.name;
    else
      return null
  });

  Handlebars.registerHelper('sublocationName', (location) => {
    if (location._sublocation)
      return location._sublocation.name;
    else
      return null
  });

  Handlebars.registerHelper('printPhotos', (location) => {

    if (location._track)
      return location._track.print_photos
        .filter((photo) => photo.order_printout)
        .sort((a, b) => a.order_printout - b.order_printout)
        .slice(0, 4);

    if (location._sublocation)
    return location._sublocation.print_photos
      .filter((photo) => photo.order_printout)
      .sort((a, b) => a.order_printout - b.order_printout)
      .slice(0, 4);

    if (typeof location.slideshow_photos === 'undefined' || location.slideshow_photos.length === 0)
      return location.photos.filter((photo) => photo.show_in_slideshow).slice(0, 4);
    return location.slideshow_photos
      .sort((a, b) => a.order - b.order)
      .map((slideshowPhoto) => slideshowPhoto.photo_id)
      .map((id) => location.photos.find((photo) => photo.id === id))
      .filter((photo) => photo && typeof photo.url !== 'undefined');
  });

  //Add flag for landscape print
  Handlebars.registerHelper('photos2thumbs', (photos, flag) => {
    if(flag){
      return photos.map((photo) => photo.url.replace(/(\.[\w\d_-]+)$/i, '$1'));
    }else{
      return photos.map((photo) => photo.url.replace(/(\.[\w\d_-]+)$/i, '_slideshow$1'));
    }
  });

  Handlebars.registerHelper('increment', (num) => parseInt(num, 10) + 1);
  Handlebars.registerHelper('decrement', (num) => parseInt(num, 10) - 1);

  // shamelessly stolen from http://stackoverflow.com/a/16315366
  Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {
    switch (operator) {
      case '==':
        return (v1 == v2) ? options.fn(this) : options.inverse(this);
      case '!=':
        return (v1 != v2) ? options.fn(this) : options.inverse(this);
      case '===':
        return (v1 === v2) ? options.fn(this) : options.inverse(this);
      case '!==':
        return (v1 !== v2) ? options.fn(this) : options.inverse(this);
      case '<':
        return (v1 < v2) ? options.fn(this) : options.inverse(this);
      case '<=':
        return (v1 <= v2) ? options.fn(this) : options.inverse(this);
      case '>':
        return (v1 > v2) ? options.fn(this) : options.inverse(this);
      case '>=':
        return (v1 >= v2) ? options.fn(this) : options.inverse(this);
      case '&&':
        return (v1 && v2) ? options.fn(this) : options.inverse(this);
      case '||':
        return (v1 || v2) ? options.fn(this) : options.inverse(this);
      default:
        return options.inverse(this);
    }
  });

  Handlebars.registerHelper('getPhotoOrder', (location, index) => {
    let photoTitle = '';
    let photoText = '';
    if (location._track){
      var loc = location._track.print_photos.filter((photo) => photo.order_printout)
        .sort((a, b) => a.order_printout - b.order_printout)
        .slice(0, 4);
        if(loc[index] && loc[index].text_show_in_slideshow == 1)
        {
          if(loc[index].photo_texts.length > 0){
            var text = loc[index].photo_texts.filter((text)=>{
              return lang.locale.toUpperCase()==text.language;
            });
            if (typeof text === 'undefined' || text.length === 0){
                return false;
            }
            else{
              photoTitle = '';
              if(text[0].name !== null){
                photoTitle = text[0].name;
              }
              photoText ='';
              if( text[0].text !== null){
                photoText = text[0].text;

              }
              var result = "<br /><span class='image_title'><strong>"+photoTitle+"</strong></span><p>"+photoText+"</p>";
              return result;
          }
        }
      }
      return false;
    }

    if (typeof location.slideshow_photos === 'undefined' || location.slideshow_photos.length === 0){
      var loc = location.photos.filter((photo) => photo.show_in_slideshow).slice(0, 4);

      if(loc[index] && loc[index].text_show_in_slideshow == 1)
      {
        if(loc[index].photo_texts.length > 0){
          var text = loc[index].photo_texts.filter((text)=>{
            return lang.locale.toUpperCase()==text.language;
          });
          if (typeof text === 'undefined' || text.length === 0){
              return false;
          }
          else{
            photoTitle = '';
            if(text[0].name !== null){
  		        photoTitle = text[0].name;

            }
            photoText ='';
            if( text[0].text !== null){
              photoText = text[0].text;

            }
             // var result = "<br /><span class='image_title'>"+text[0].name+"</span><p>"+text[0].text+"</p>";
            var result = "<br /><span class='image_title'><strong>"+photoTitle+"</strong></span><p>"+photoText+"</p>";
            return result;
          }
        }
      }
      return false;
    }

    var loc = location.slideshow_photos
      .sort((a, b) => a.order - b.order)
      .map((slideshowPhoto) => slideshowPhoto.photo_id)
      .map((id) => location.photos.find((photo) => photo.id === id))
      .filter((photo) => photo && typeof photo.url !== 'undefined');

      if(typeof loc[index] !== 'undefined')
      {
        if(loc[index].text_show_in_slideshow == 1) {
        if(loc[index].photo_texts.length > 0){
          var text = loc[index].photo_texts.filter((text)=>{
            return lang.locale.toUpperCase()==text.language;
          });
          if (typeof text === 'undefined' || text.length === 0){
              return false;
          }
          else{
            photoTitle = '';
            if(text[0].name !== null){
  		        photoTitle = text[0].name;
            }
            photoText = '';
            if( text[0].text !== null){
              photoText = text[0].text;
            }
            var result = "<br /><span class='image_title'><strong>"+photoTitle+"</strong></span><p>"+photoText+"</p>";
  		      // var result = "<br /><span class='image_title'>"+text[0].name+"</span><p>"+text[0].text+"</p>";
            return result;
          }
        }
      }
      }

      return false;

  });

  Handlebars.registerHelper('getPhotoLength', (location) => {
    if (location._track){
      var loc = location._track.print_photos.filter((photo) => photo.order_printout)
        .sort((a, b) => a.order_printout - b.order_printout)
        .slice(0, 4);
        return loc.length-1;
    }

    if (typeof location.slideshow_photos === 'undefined' || location.slideshow_photos.length === 0){
      var loc = location.photos.filter((photo) => photo.show_in_slideshow).slice(0, 4);
      return loc.length-1;
    }

    var loc = location.slideshow_photos
      .sort((a, b) => a.order - b.order)
      .map((slideshowPhoto) => slideshowPhoto.photo_id)
      .map((id) => location.photos.find((photo) => photo.id === id))
      .filter((photo) => photo && typeof photo.url !== 'undefined');
    return loc.length-1;

  });


  Handlebars.registerHelper('slideShowText', (location) => {
    if (location._track){
      var textfields = location._track.track_data.slide_show_text_field_data;
      if ($.isEmptyObject(textfields)){
        return false;
      }
      else{
        return textfields.textfield;
      }
    }
    else{
      var textfields =  location.slide_show_text_field_data;
      if ($.isEmptyObject(textfields)){
        return false;
      }
      else{
        return textfields.textfield;
      }
    }

  });

Handlebars.registerHelper('getPhotoTextClass', (location, index) => {
    var maxlen = 0;
    var text = '';
    var phototext = '';
    var phototext2 = '';
    if (location._track){
      var loc = location._track.print_photos.filter((photo) => photo.order_printout)
        .sort((a, b) => a.order_printout - b.order_printout)
        .slice(0, 4);
        if(loc.length > 0){
          for(let i=0; i<loc.length;i++){
            phototext = '';
            if(loc[i] && loc[i].text_show_in_slideshow === 1){
              if(loc[i].photo_texts.length > 0){
                text = loc[i].photo_texts.filter((text)=>{
                  return lang.locale.toUpperCase()==text.language;
                });
                if(text.length > 0) {
                  if(text[0].text !==  null){
                    phototext = text[0].text;
                  }
                }
              }
            }

            if(index == 0){
                var secondmaxlength = 0;
                for(let j=1; j<loc.length;j++){
                  phototext2 = '';
                  if(loc[j].text_show_in_slideshow == 1){
                    if(loc[i].photo_texts.length > 0){
                      text = loc[j].photo_texts.filter((text)=>{
                        return lang.locale.toUpperCase()==text.language;
                      });
                      if(text.length > 0){
                        if(text[0].text !==  null){
                          phototext2 = text[0].text;
                        }
                      }
                    }
                  }
                  if(phototext2.length > secondmaxlength){
                    secondmaxlength = phototext2.length;
                  }
                }
                if(secondmaxlength == 0 && loc.length > 1){
                  if(loc.length < 4){
                    return 'medium2';
                  }
                  return 'large';
                }
                if(phototext.length >= 250){
                  if(loc.length == 1){
                    return 'xsmall1';
                  }else if(loc.length < 4){
                    return 'xsmall2';
                  }
                  return 'xsmall';
                }else if(phototext.length >= 130){
                  if(loc.length == 1){
                    return 'small1';
                  }else if(loc.length < 4){
                    return 'small2';
                  }
                  return 'small';
                }else if(phototext.length > 0){
                  if(loc.length == 1){
                    return 'medium1';
                  }else if(loc.length < 4){
                    return 'medium2';
                  }
                  return 'medium';
                }else {
                  if(loc.length == 1){
                    return 'large1';
                  }else if(loc.length < 4){
                    return 'large2';
                  }
                  return 'large';
                }
              }
              else{
                if(i != 0){
                  if(phototext.length > maxlen){
                    maxlen = phototext.length;
                  }
                }
              }
          }
          if(maxlen >= 100){
            if(loc.length < 4){
              return 'xsmall2 half';
            }



            return 'xsmall';
          }else if(maxlen >= 50){
            if(loc.length < 4){
              return 'small2 half';
            }
            return 'small';
          }else if(maxlen > 0){
            if(loc.length < 4){
              return 'medium2 half';
            }
            return 'medium';
          }else{
            if(loc.length < 4){
              return 'large2 half';
            }
            return 'large';
          }
        }
        else{
          return 'large';
        }


    }

    if (typeof location.slideshow_photos === 'undefined' || location.slideshow_photos.length === 0){
      var loc = location.photos.filter((photo) => photo.show_in_slideshow).slice(0, 4);
      if(loc.length > 0){
          for(let i=0; i<loc.length;i++){
            phototext = '';
            if(loc[i] && loc[i].text_show_in_slideshow === 1) {
              if(loc[i].photo_texts.length > 0){
                text = loc[i].photo_texts.filter((text)=>{
                  return lang.locale.toUpperCase()==text.language;
                });
                if(text.length > 0){
                  if(text[0].text !== null){
                    phototext = text[0].text;
                  }
                }
              }
            }
            if(index == 0){
              var secondmaxlength = 0;
                for(let j=1; j<loc.length;j++){
                  phototext2 = '';
                  if(loc[j].text_show_in_slideshow == 1) {
                    if(loc[j].photo_texts.length > 0){
                      text = loc[j].photo_texts.filter((text)=>{
                        return lang.locale.toUpperCase()==text.language;
                      });
                      if(text.length > 0){
                        if(text[0].text !== null){
                          phototext2 = text[0].text;
                        }
                      }
                    }
                  }
                  if(phototext2.length > secondmaxlength){
                    secondmaxlength = phototext2.length;
                  }
                }
                if(secondmaxlength == 0 && loc.length > 1){
                  if(loc.length < 4){
                    return 'medium2';
                  }
                  return 'large';
                }
                if(phototext.length >= 250){
                  if(loc.length == 1){
                    return 'xsmall1';
                  }else if(loc.length < 4){
                    return 'xsmall2';
                  }
                  return 'xsmall';
                }else if(phototext.length >= 130){
                  if(loc.length == 1){
                    return 'small1';
                  }else if(loc.length < 4){
                    return 'small2';
                  }
                  return 'small';
                }else if(phototext.length > 0){
                  if(loc.length == 1){
                    return 'medium1';
                  }else if(loc.length < 4){
                    return 'medium2';
                  }
                  return 'medium';
                }else {
                  if(loc.length == 1){
                    return 'large1';
                  }else if(loc.length < 4){
                    return 'large2';
                  }
                  return 'large';
                }
              }
              else{
                if(i != 0){
                  if(phototext.length > maxlen){
                    maxlen = phototext.length;
                  }
                }
              }
          }
          if(maxlen >= 100){
            if(loc.length < 4){
              return 'xsmall2 half';
            }


            return 'xsmall';
          }else if(maxlen >= 50){
            if(loc.length < 4){
              return 'small2 half';
            }
            return 'small';
          }else if(maxlen > 0){
            if(loc.length < 4){
              return 'medium2 half';
            }
            return 'medium';
          }else{
            if(loc.length < 4){
              return 'large2 half';
            }
            return 'large';
          }
        }
        else{
          return '';
        }
    }

    var loc = location.slideshow_photos
      .sort((a, b) => a.order - b.order)
      .map((slideshowPhoto) => slideshowPhoto.photo_id)
      .map((id) => location.photos.find((photo) => photo.id === id))
      .filter((photo) => photo && typeof photo.url !== 'undefined');
      if(loc.length > 0){
          for(let i=0; i<loc.length;i++) {
            phototext = '';
            if(loc[i] && loc[i].text_show_in_slideshow === 1){
              if(loc[i].photo_texts.length > 0){
                text = loc[i].photo_texts.filter((text)=>{
                  return lang.locale.toUpperCase()==text.language;
                });
                if(text.length > 0){
                  if(text[0].text !== null){
                    phototext = text[0].text;
                  }
                }
              }
            }
            if(index == 0){
                var secondmaxlength = 0;
                for(let j=1; j<loc.length;j++){
                  phototext2 = '';
                  if(loc[j].text_show_in_slideshow == 1){
                    if(loc[j].photo_texts.length > 0){
                      text = loc[j].photo_texts.filter((text)=>{
                        return lang.locale.toUpperCase()==text.language;
                      });
                      if(text.length > 0){
                        if(text[0].text !== null){
                          phototext2 = text[0].text;
                        }
                      }
                    }
                  }
                  if(phototext2.length > secondmaxlength){
                    secondmaxlength = phototext2.length;
                  }
                }
                if(secondmaxlength == 0 && loc.length > 1){
                  if(loc.length < 4){
                    return 'medium2';
                  }
                  return 'large';
                }
                if(phototext.length >= 250){
                  if(loc.length == 1){
                    return 'xsmall1';
                  }else if(loc.length < 4){
                    return 'xsmall2';
                  }
                  return 'xsmall';
                }else if(phototext.length >= 130){
                  if(loc.length == 1){
                    return 'small1';
                  }else if(loc.length < 4){
                    return 'small2';
                  }
                  return 'small';
                }else if(phototext.length > 0){
                  if(loc.length == 1){
                    return 'medium1';
                  }else if(loc.length < 4){
                    return 'medium2';
                  }
                  return 'medium';
                }else {
                  if(loc.length == 1){
                    return 'large1';
                  }else if(loc.length < 4){
                    return 'large2';
                  }
                  return 'large';
                }
              }
              else{
                if(i != 0){
                  if(phototext.length > maxlen){
                    maxlen = phototext.length;
                  }
                }
              }
          }
          if(maxlen >= 100){
            if(loc.length < 4){
              return 'xsmall2 half';
            }


            return 'xsmall';
          }else if(maxlen >= 50){
            if(loc.length < 4){
              return 'small2 half';
            }
            return 'small';
          }else if(maxlen > 0){
            if(loc.length < 4){
              return 'medium2 half';
            }
            return 'medium';
          }else{
            if(loc.length < 4){
              return 'large2 half';
            }
            return 'large';
          }
        }
        else{
          return '';
        }

  });

  Handlebars.registerHelper('getLocationID', (location) => {
    if (location._track)
      return location._track.track_location_id;
    else if (location._sublocation)
      return location._sublocation.id;
    else
      return location.id;
  });

  Handlebars.registerHelper('eq', function (v1, v2) {
    return v1 === v2;
  });

};


